import Vue from 'vue'
import Vuex from 'vuex'
import kefu from './modules/kefu'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		//这里放全局参数
		token: localStorage.getItem('token') || '',
		userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
		chatInfo: null,
		config: JSON.parse(localStorage.getItem('config') || '{}'),
	},
	mutations: {
		setUserInfo(state, Value) {
			state.userInfo = Value
			localStorage.setItem('userInfo', JSON.stringify(Value))
		},
		setToken(state, Value) {
			state.token = Value
			localStorage.setItem('token', Value)
		},
		setConfig(state, Value) {
			state.config = Value
			try {
				const pureConfig = JSON.parse(JSON.stringify(Value));
				localStorage.setItem('config', JSON.stringify(pureConfig))
			} catch (e) {
				console.warn('Config 包含循环引用，已跳过本地缓存存储', e)
			}
		},
		SET_CHAT_INFO(state, value) {
			state.chatInfo = value
		},
		CLEAR_CHAT_INFO(state) {
			state.chatInfo = null
		}
	},
	getters: {
		//get方法
		getUserInfo: state => state.userInfo,
		getChatInfo: state => state.chatInfo,
		getToken: state => state.token,
		getConfig: state => state.config,
	},
	actions: {
		// 设置（跳转前）
		setChatInfo({
			commit
		}, value) {
			commit('SET_CHAT_INFO', value)
		},

		// 消费（新页面）
		consumeChatInfo({
			state,
			commit
		}) {
			const info = state.chatInfo
			commit('CLEAR_CHAT_INFO')
			return info
		}
	},
	modules: {
		kefu
	}
})